const gettingStarted = productType => [{
  productType: 'fund',
  title: '¿Qué es un fondo de inversión?',
  description: 'Un fondo de inversión es un vehículo que reúne el dinero de diversos ciudadanos o compañías para invertirlo de modo conjunto, delegando en un gestor la capacidad de decidir dónde hacerlo.',
  href: `/${productType.slug}#que-es-un-fondo-de-inversion`
}, {
  productType: 'fund',
  title: 'Por qué invertir en fondos de inversión?',
  description: 'Los fondos de inversión ofrecen numerosas ventajas para la inversión a largo plazo: diversificación, ventajas fiscales, seguridad, gestión profesional, transparencia',
  href: `/${productType.slug}#por-que-invertir-en-fondos-de-inversion`
}, {
  productType: 'fund',
  title: '¿Qué rentabilidades tienen los fondos?',
  description: 'Hay tanta diversidad en los fondos de inversión que resulta complicado dar una cifra agregada. Dependerá sobre todo del riesgo que estamos dispuestos a asumir y el tipo de activo elegido.',
  href: `/${productType.slug}#que-rentabilidades-tienen-los-fondos`
}, {
  productType: 'fund',
  title: '¿Qué riesgos tienen los fondos?',
  description: 'El riesgo principal al invertir en fondos es que las rentabilidades sean negativas, ya sea porque el equipo gestor se ha equivocado en sus decisiones o porque hemos elegido un tipo de activo que ha ido muy mal.',
  href: `/${productType.slug}#que-riesgo-tienen-los-fondos`
}, {
  productType: 'fund',
  title: '¿Qué fondo de inversión elegir?',
  description: 'Para responder esta pregunta primero hay que hacerse otras, como para qué necesitamos el dinero, qué tipo de rentabilidad necesitaremos para alcanzar nuestros objetivos y, especialmente, hasta qué punto vamos a tener que necesitar ese dinero en los próximos meses.',
  href: `/${productType.slug}#que-fondo-de-inversion-elegir`
}, {
  productType: 'fund',
  title: '¿Cómo invertir en fondos de inversión?',
  description: 'Hay dos opciones para invertir en fondos de inversión, hacerlo directamente a través de la gestora que los ‘fabrica’ o a través de otras plataformas de fondos, como supermercados o plataformas de fondos. Esto, con independencia de que lo hagamos personalmente o lo haga un asesor por nosotros.',
  href: `/${productType.slug}#como-invertir-en-fondos-de-inversion`
}, {
  productType: 'fund',
  title: '¿Qué son los reembolsos? ¿Y las suscripciones?',
  description: 'En fondos de inversión, los inversores se denominan partícipes y cuando hablamos de meter dinero se habla de suscripciones, mientras que si retiramos hacemos un reembolso. Las salidas de dinero se pueden hacer de golpe (reembolso total) o sacando sólo una parte (reembolso parcial).',
  href: `/${productType.slug}#que-son-los-reembolsos-y-las-suscripciones`
}, {
  productType: 'fund',
  title: '¿Cómo funciona un fondo de inversión?',
  description: 'El fondo invierte el dinero de todos los partícipes según su política de inversión y el criterio de su equipo gestor, de acuerdo con las bases que ha establecido en el folleto del fondo de inversión.',
  href: `/${productType.slug}#como-funciona-un-fondo-de-inversion`
}, {
  productType: 'plan',
  title: '¿Qué es un plan de pensiones?',
  description: `La definición de un plan de pensiones más sencilla es
    que se trata de un producto de ahorro a largo plazo pensado para la
    jubilación. Es el producto más popular y el que más comercializan
    bancos y entidades financiera a la hora de planificar el retiro.`,
  href: `/${productType.slug}#que-es-un-plan-de-pensiones`
}, {
  productType: 'plan',
  title: 'Diferencia entre un plan de pensiones y un plan de jubilación',
  description: `Los planes de pensiones están pensados para tener una buena
    jubilación. De ahí que sea fácil confundirlos con los planes de
    jubilación cuando en realidad se trata de dos productos de ahorro a
    largo plazo completamente distintos, con unas características fiscales
    y un funcionamiento diferente.`,
  href: `/${productType.slug}#diferencia-entre-un-plan-de-pensiones-y-un-plan-de-jubilacion`
}, {
  productType: 'plan',
  title: '¿Por qué contratar un plan de pensiones?',
  description: `Un plan de pensiones es un complemento a la pensión pública del
    Estado, cuyo futuro no está ni mucho menos asegurado en las
    condiciones actuales. Incluso aunque sí lo estuviesen, una de las
    máximas de la planificación financiera y la inversión es diversificar.
    En otras palabras, no poner todos los huevos en la misma cesta.`,
  href: `/${productType.slug}#por-que-contratar-un-plan-de-pensiones`
}, {
  productType: 'plan',
  title: 'Las pensiones de la Seguridad Social',
  description: `La mayoría de los españoles confía en la pensión pública de la
    Seguridad Social para asegurar su jubilación. El problema es que la
    forma en la que se calcula la pensión pública puede variar según lo
    que acuerden los partidos políticos. De hecho, la última reforma de
    las pensiones de 2013 ya lo hizo y a partir de 2019 cambiará incluso
    la forma en la se revalorizan las pensiones públicas.`,
  href: `/${productType.slug}#las-pensiones-de-la-seguridad-social`
}, {
  productType: 'plan',
  title: '¿Cómo funcionan los planes de pensiones?',
  description: `El funcionamiento de un plan de pensiones es más
    sencillo de lo que pueda parecer. Básicamente, un ahorrador decide
    invertir su dinero en el plan y los gestores del fondo de pensiones se
    encargan de hacer crecer el dinero invirtiendo según los límites que
    marca la política de inversión del plan.`,
  href: `/${productType.slug}#como-funcionan-los-planes-de-pensiones`
}, {
  productType: 'plan',
  title: 'Ley de planes de pensiones',
  description: `Los planes de pensiones son un producto de inversión a largo plazo
    regulado. El Real Decreto Legislativo 1/2002, de 29 de noviembre, por
    el que se aprueba el texto refundido de la Ley de Regulación de los
    Planes y Fondos de Pensiones y sus posteriores modificaciones.`,
  href: `/${productType.slug}#ley-de-planes-de-pensiones`
}];
export { gettingStarted };